import { render, staticRenderFns } from "./ReadyToSubmitAlert.vue?vue&type=template&id=6f9053e2&scoped=true"
import script from "./ReadyToSubmitAlert.vue?vue&type=script&lang=js"
export * from "./ReadyToSubmitAlert.vue?vue&type=script&lang=js"
import style0 from "./ReadyToSubmitAlert.vue?vue&type=style&index=0&id=6f9053e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9053e2",
  null
  
)

export default component.exports